import { appTypes, authTypes } from 'redux-utils/types/index';
import { identifyUser, reset, track } from 'analytics';
import { AUTH_EVENTS, LAYOUT_EVENTS } from 'analytics/events';
import ls from 'lib/core/storageFactory';

function handleLoginSuccess(action) {
  const { response, request } = action.payload;

  identifyUser(response.email, {
    username: request.username,
    group_id: response.group_id,
    client: ls.get('client'),
    status: response.status,
  });

  track(AUTH_EVENTS.LOGIN_SUCCESS, {
    login_method: 'credentials',
  });
}

function handleAnalyticsRedirect(action) {
  // Note: identifyUser() is not needed here as it's already called during initial login.
  // This action fires on analytics redirect flow, which happens after successful auth.
  // We still track the login success event for analytics purposes.
  
  track(AUTH_EVENTS.LOGIN_SUCCESS, {
    login_method: 'analytics_redirect',
  });
}

function handleLoginFailure() {
  track(AUTH_EVENTS.LOGIN_FAILED);
}

function handleLogout() {
  track(AUTH_EVENTS.LOGOUT);
  reset();
}

function handleInvalidToken() {
  track(AUTH_EVENTS.SESSION_EXPIRED);
  reset();
}

function normaliseRoutes(layout) {
  if (!Array.isArray(layout)) return [];
  return layout.map(r => ({
    routeID: r?.routeID,
    title: r?.title,
  }));
}

function handleLayoutSuccess(action) {
  const layout = action?.payload?.response?.data?.layout;
  const routes = normaliseRoutes(layout);
  track(LAYOUT_EVENTS.FETCH_SUCCESS, {
    route_count: routes.length,
    route_ids: routes.map(r => r.routeID).filter(Boolean),
    routes,
    from_cache: Boolean(action?.payload?.fromCache),
  });
}

function handleLayoutFailure(action) {
  track(LAYOUT_EVENTS.FETCH_FAILED, {
    message: action?.payload?.message ?? 'unknown',
  });
}

const actionHandlers = {
  [authTypes.login.success]: handleLoginSuccess,
  [authTypes.analyticsRedirect]: handleAnalyticsRedirect,
  [authTypes.login.failure]: handleLoginFailure,
  [authTypes.logout.success]: handleLogout,
  [authTypes.logout.failure]: handleLogout,
  [authTypes.inValidToken]: handleInvalidToken,
  [appTypes.getLayout.success]: handleLayoutSuccess,
  [appTypes.getLayout.failure]: handleLayoutFailure,
};

const amplitudeMiddleware = () => next => action => {
  const result = next(action);

  const handler = actionHandlers[action.type];
  if (handler) {
    try {
      handler(action);
    } catch (err) {
      console.error('[Amplitude] Middleware error:', err);
    }
  }

  return result;
};

export default amplitudeMiddleware;
